import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ClickOutside from 'vue-click-outside';
import store from '@/store';
import util from '@/libs/util';
import { mapState, mapActions } from 'vuex';
import { changePwd, sendEmail, bindEmail } from '@api/u8.api.admin';
export default {
  data: function data() {
    return {
      userPanelVisible: false,
      userRole: '',
      rightMenuGroup: [{
        name: '官网',
        desc: 'U8SDK官方网站',
        icon: 'iconfont u8-shouye',
        path: 'http://www.u8sdk.com'
      }, {
        name: '博客',
        desc: 'U8SDK技术博客',
        icon: 'iconfont u8-news',
        path: 'http://www.uustory.com'
      }, {
        name: '视频教程',
        desc: 'U8SDK视频教程',
        icon: 'iconfont u8-video',
        path: 'https://www.bilibili.com/video/BV1QC4y1h7vR/'
      }, {
        name: '文档',
        desc: 'U8SDK在线文档',
        icon: 'iconfont u8-help',
        path: 'http://www.6xsdk.com/document.html'
      }],
      changePwdDialogVisible: false,
      pwdForm: {
        id: '',
        oldPwd: '',
        newPwd: ''
      },
      pwdRules: {
        oldPwd: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        newPwd: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 20,
          message: '密码为6-20个字符',
          trigger: 'blur'
        }]
      },
      bindDialogVisible: false,
      bindForm: {
        id: '',
        email: '',
        code: ''
      },
      bindRules: {
        email: [{
          required: true,
          message: '请输入邮箱',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入邮箱验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('u8sdk/menu', {
    collapse: function collapse(state) {
      return state.collapse;
    }
  })), mapState('u8sdk/user', {
    info: function info(state) {
      return state.info;
    }
  })),
  directives: {
    ClickOutside: ClickOutside
  },
  filters: {
    ellipsis: function ellipsis(value) {
      if (!value) return '';

      if (value.length > 14) {
        return value.slice(0, 13) + '...';
      }

      return value;
    }
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('u8sdk/user', ['updateEmail'])), mapActions('u8sdk/menu', ['collapseToggle'])), {}, {
    toggleSidebar: function toggleSidebar() {
      this.collapseToggle();
    },
    onRightMenuClicked: function onRightMenuClicked(item) {
      util.open(item.path);
    },
    hideUserPanel: function hideUserPanel() {
      this.userPanelVisible = false;
    },
    logout: function logout() {
      this.userPanelVisible = false;
      store.dispatch('u8sdk/account/logout', {
        confirm: true
      });
    },
    showPwdDialog: function showPwdDialog() {
      this.pwdForm = {};
      this.userPanelVisible = false;
      this.changePwdDialogVisible = true;
    },
    showBindDialog: function showBindDialog() {
      this.bindForm = {};
      this.userPanelVisible = false;
      this.bindDialogVisible = true;
    },
    sendBindEmail: function sendBindEmail() {
      var _this = this;

      if (!this.bindForm.email || this.bindForm.email === undefined || this.bindForm.email.length === 0) {
        this.$message({
          message: '请输入邮箱',
          type: 'warning'
        });
        return;
      }

      sendEmail({
        'email': this.bindForm.email
      }).then(function (res) {
        _this.$message({
          message: '发送成功',
          type: 'success'
        });
      }).catch(function (err) {
        console.log('changePwd err', err);
      });
    },
    submitPwdForm: function submitPwdForm() {
      var _this2 = this;

      //添加或者编辑表单提交
      this.pwdForm.id = this.info.id;
      this.$refs['pwdForm'].validate(function (valid) {
        if (valid) {
          changePwd(_objectSpread({}, _this2.pwdForm)).then(function (res) {
            _this2.changePwdDialogVisible = false;

            _this2.$message({
              message: '操作成功',
              type: 'success'
            });
          }).catch(function (err) {
            console.log('changePwd err', err);
          });
        } else {
          return false;
        }
      });
    },
    submitBindForm: function submitBindForm() {
      var _this3 = this;

      //添加或者编辑表单提交
      this.bindForm.id = this.info.id;
      this.$refs['bindForm'].validate(function (valid) {
        if (valid) {
          bindEmail(_objectSpread({}, _this3.bindForm)).then(function (res) {
            _this3.bindDialogVisible = false;

            _this3.updateEmail(_this3.bindForm.email);

            _this3.$message({
              message: '操作成功',
              type: 'success'
            });
          }).catch(function (err) {
            console.log('bindEmail err', err);
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      //添加或者编辑表单，清理表单数据
      this.changePwdDialogVisible = false;
      this.bindDialogVisible = false;

      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
        this.$refs[formName].clearValidate();
      } else {
        console.log("the form is not exists." + formName);
      }
    }
  })
};